/**
 * Promo popup — default (fallback) content.
 *
 * The <PromoPopupModal /> component ALWAYS starts from these values and
 * then merges in whatever the admin has saved server-side (via
 * `GET /api/promo-popup/active`). Anything missing from the admin doc
 * falls back to this file, so the popup is safe even if the backend
 * hasn't been configured yet.
 *
 * WHEN YOU LAUNCH A NEW PROMO:
 * 1. Update the strings below OR edit through /admin/promo (recommended).
 * 2. If you want returning visitors who already dismissed the previous
 *    promo to see the new one, BUMP `version` (e.g. "nov-2026" → "dec-2026").
 * 3. Set `enabled: false` to fully hide the popup site-wide.
 */
export const PROMO_POPUP_DEFAULT = {
  enabled: true,

  // Change this to force everyone who dismissed the OLD promo to see the NEW one.
  version: '2026-11-alapozo',

  // How long (days) to hide after a visitor closes the popup.
  cooldown_days: 1,

  // Delay before the popup appears (ms). Gives visitors time to orient.
  delay_ms: 15000,

  // Header / branding
  brand:        'OROSZ COACHING',
  brand_sub:    'OKLEVELES SPORTEDZŐ · SZEMÉLYRE SZABOTT EDZÉS',
  venue:        'MISKOLC · BB GYM',

  // Body copy
  eyebrow:         'BEMUTATKOZÓ AJÁNLAT',
  headline_line1: 'INGYENES',
  headline_line2: 'KONZULTÁCIÓ',
  headline_badge: 'NOVEMBERIG',

  // Bemutatkozó bullet — a felmérés most ingyenes (lásd /admin/beallitasok).
  bullet_lead:    '+ ingyenes',
  bullet_accent:  'állapotfelmérés',
  bullet_sub:     'a 20 perces konzultáció és a részletes állapotfelmérés is teljesen díjmentes',

  // Discount block
  discount_amount:  '-22 000 Ft',
  discount_sub:     'az első havi bérletedből',
  discount_fine:    'bármelyik program · az első 10 bérletvásárlónak',

  // CTA — button label (the click always opens the Booking modal on the homepage
  // AND fires a Meta Pixel `Lead` event).
  cta_label: 'FOGLALJ INGYENES KONZULTÁCIÓT',
  // 'booking' → foglalási űrlap nyílik; 'link' → cta_href-re navigál.
  cta_action: 'booking',
  cta_href: '',

  // Footer contact
  website: 'oroszcoaching.hu',
  phone:   '+36 70 237 8299',

  // Promo TÍPUSOK. A bekapcsolt (enabled !== false) típusok közül a látogató
  // véletlenszerűen egyet lát — böngészőre "ragadva", hogy visszatérőként is
  // ugyanazt kapja. Az adminban típusonként ki/be kapcsolható.
  variants: [
    {
      key: 'A',
      label: 'Alapozó Program',
      enabled: true,
      eyebrow:        'ÚJ: 8 HETES ALAPOZÓ PROGRAM',
      headline_line1: 'ALAPOZÓ',
      headline_line2: 'PROGRAM',
      headline_badge: 'CSAK 10 HELY',
      bullet_lead:    'Heti 2 edzés,',
      bullet_accent:  'ebből egy velem',
      bullet_sub:     'felmérés, egyéni terv és záró értékelés — kezdőknek és visszatérőknek',
      discount_amount: '25 000 Ft-tól',
      discount_sub:    'a teljes 8 hétre',
      discount_fine:   'jelentkezés november 15-ig · kezdés november második felében',
      cta_label:  'MEGNÉZEM AZ ALAPOZÓT',
      cta_action: 'link',
      cta_href:   '/alapozo',
    },
    {
      key: 'B',
      label: 'Ingyenes PDF útmutató',
      enabled: true,
      eyebrow:        'INGYENES SZAKMAI ANYAG',
      headline_line1: 'INGYENES',
      headline_line2: 'PDF ÚTMUTATÓ',
      headline_badge: '5 ALAPELV',
      bullet_lead:    'Amit megtanulsz:',
      bullet_accent:  'a fejlődés 5 alapelve',
      bullet_sub:     'progresszív túlterhelés, technika, regeneráció, alvás, táplálkozás',
      discount_amount: '0 Ft',
      discount_sub:    'azonnali letöltés e-mailben',
      discount_fine:   'csak az e-mail címed kell · bármikor leiratkozhatsz',
      cta_label:  'KÉREM AZ INGYENES PDF-ET',
      cta_action: 'link',
      cta_href:   '/ingyenes-pdf',
    },
    {
      key: 'C',
      label: '1 napos minta étrend',
      enabled: true,
      eyebrow:        'SZEMÉLYRE SZABOTT MINTA',
      headline_line1: '1 NAPOS',
      headline_line2: 'MINTA ÉTREND',
      headline_badge: 'A TE ADATAIDRA',
      bullet_lead:    'Kiszámolom a',
      bullet_accent:  'kalóriád és a makróid',
      bullet_sub:     'majd a generátorom összerak egy teljes napot — 5 étkezés, grammra pontosan',
      discount_amount: '0 Ft',
      discount_sub:    'PDF-ben, azonnal',
      discount_fine:   'vegetáriánus, vegán és laktózmentes változatban is',
      cta_label:  'KÉREM A MINTA ÉTRENDET',
      cta_action: 'link',
      cta_href:   '/minta-etrend',
    },
  ],
};

export default PROMO_POPUP_DEFAULT;
